import { useState } from 'react';

export default function ExportButtons({ mode, inputs, rows, summary }) {
  const [busy, setBusy] = useState(null);

  const handlePdf = async () => {
    setBusy('pdf');
    try {
      // Dynamic import keeps html2pdf (~150KB) out of the initial page bundle.
      const { exportSimplePdf, exportDetailPdf } = await import('../../exports/pdf.js');
      const fn = mode === 'detail' ? exportDetailPdf : exportSimplePdf;
      await fn();
    } catch (err) {
      console.error('PDF export failed', err);
      alert('PDF export failed — see console for details.');
    } finally {
      setBusy(null);
    }
  };

  const handleExcel = async () => {
    setBusy('xlsx');
    try {
      // Dynamic import keeps SheetJS (~150KB) out of the initial page bundle.
      const [{ exportExcel }, engine] = await Promise.all([
        import('../../exports/excel.js'),
        import('../../engine/index.js'),
      ]);
      const perTier = engine.perTierPnl(rows);
      let sensitivity = [];
      try {
        sensitivity = engine.tornado(inputs);
      } catch (e) {
        // tornado is best-effort; skip if it throws so the export still ships
        console.warn('Tornado sweep failed:', e);
      }
      await exportExcel({
        inputs,
        rows,
        summary,
        perTier,
        sensitivity,
        regional: [],
      });
    } catch (err) {
      console.error('Excel export failed', err);
      alert('Excel export failed — see console for details.');
    } finally {
      setBusy(null);
    }
  };

  const baseCls =
    'inline-flex items-center gap-2 rounded-sw px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-50';

  return (
    <div className="flex gap-2 no-print">
      <button
        onClick={handlePdf}
        disabled={busy !== null}
        className={`${baseCls} bg-carbon-800 text-white hover:bg-carbon-900`}
        title={mode === 'detail' ? 'Export full investor deck' : 'Export 2-page summary'}
      >
        {busy === 'pdf' ? 'Exporting…' : 'PDF'}
      </button>
      <button
        onClick={handleExcel}
        disabled={busy !== null}
        className={`${baseCls} bg-white border border-carbon-200 text-carbon-800 hover:bg-carbon-50`}
        title="Export workbook for finance"
      >
        {busy === 'xlsx' ? 'Exporting…' : 'Excel'}
      </button>
    </div>
  );
}
